import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    // Extract venue and location data
    const venueName = publicData?.venue || publicData?.venueName;
    const venueText = venueName ? venueName.split(',')[0].trim() : null;
    const locationText =
      publicData?.event_location ||
      publicData?.location ||
      publicData?.venueLocation ||
      [publicData?.city, publicData?.state].filter(Boolean).join(', ');

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>
        {/* Venue */}
        {venueText && (
          <div className={css.locationDetail}>
            <h3 className={css.locationDetailLabel}>Venue</h3>
            <p className={css.locationDetailValue}>{venueText}</p>
          </div>
        )}

        {/* Location Address */}
        {locationText && (
          <div className={css.locationDetail}>
            <h3 className={css.locationDetailLabel}>Address</h3>
            <p className={css.locationDetailValue}>{locationText}</p>
          </div>
        )}

        {/* Map */}
        {this.state.isStatic ? (
          <button
            type="button"
            className={css.map}
            aria-label={`Activate interactive map${venueText ? ` for ${venueText}` : ''}`}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
      </section>
    );
  }
}

export default SectionMapMaybe;
